import { useLang } from "@/i18n/LanguageContext";
import { COMPANY } from "../company";
import en from "./en";
import nl from "./nl";
import de from "./de";
import it from "./it";
import es from "./es";
import sq from "./sq";

const BUILDERS = { en, nl, de, it, es, sq };

// Legal & support texts in the visitor's site language (same 6 languages as the rest of the site).
export function useLegal() {
  const { lang } = useLang();
  return (BUILDERS[lang] || en)(COMPANY);
}

// English topics are always sent to the support inbox, whatever language the visitor uses.
export const EN_TOPICS = en(COMPANY).support.topics;
